import { ResourcesConfig } from 'aws-amplify';
import { getEnv } from '@/utils/get-env';

export const amplifyConfiguration: ResourcesConfig = {
  Auth: {
    Cognito: {
      //  Amazon Cognito User Pool ID
      userPoolId: getEnv().VITE_COGNITO_USER_POOL_ID,
      // Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolClientId: getEnv().VITE_COGNITO_USER_POOL_CLIENT_ID,
    },
  },
};
